<template>
  <form v-on:submit.prevent="submitForm">
    <!-- Edit all? -->
    <div class="form-group" v-if="editing">
      <label class="form-switch">
        <input type="checkbox" v-model="editAll">
        <i class="form-icon"></i> Edit all future instances?
      </label>
    </div>

    <!-- Name -->
    <div class="form-group">
      <div class="form-group">
        <label class="form-label" for="name">Class name</label>
        <input class="form-input" type="text" id="name" v-model="event.name" required />
      </div>

      <!-- Type private/class -->
      <label class="form-label" for="type">Type of class</label>
      <select class="form-select" id="type" v-model="event.type" required>
        <option value="">Choose a type</option>
        <option value="class">Class</option>
        <option value="private">Private</option>
      </select>

       <!-- Level -->
      <label class="form-label" for="level">Level</label>
      <select class="form-select" id="level" v-model="event.level" required>
        <option value="">Choose a level</option>
        <option v-for="level in levels" :value="level.id">
          {{level.name}}
        </option>
      </select>

      <!-- Space -->
      <label class="form-label" for="space">Space</label>
      <select class="form-select" id="space" v-model="event.space" required>
        <option value="">Choose a space</option>
        <option v-for="space in spaces" :value="space.id">
          {{space.name}}
        </option>
      </select>

      <!-- Date -->
      <div class="form-group" v-if="editing && !editAll">
        <label class="form-label" for="date">Date</label>
        <input class="form-input" type="date" id="date" v-model="event.date" required />
      </div>

      <!-- Date start -->
      <div class="form-group" v-if="!editing || editAll">
        <label class="form-label" for="datestart">Start date</label>
        <input class="form-input" type="date" id="datestart" v-model="event.datestart" required />
      </div>

      <!-- Date end -->
      <div class="form-group" v-if="!editing || editAll">
        <label class="form-label" for="dateend">End date</label>
        <input class="form-input" type="date" id="dateend" v-model="event.dateend" required />
      </div>

      <!-- Time start -->
      <div class="form-group">
        <label class="form-label" for="timestart">Start time</label>
        <input class="form-input" type="time" id="timestart" v-model="event.timestart" required />
      </div>

      <!-- Time end -->
      <div class="form-group">
        <label class="form-label" for="timeend">End time</label>
        <input class="form-input" type="time" id="timeend" v-model="event.timeend" required />
      </div>

      <!-- Days of the week -->
      <div class="form-group" v-if="!editing || editAll">
        <label class="form-label" for="days">Days of week</label>
        <select class="form-select" id="days" v-model="event.days" multiple required>
          <option value="sunday">Sunday</option>
          <option value="monday">Monday</option>
          <option value="tuesday">Tuesday</option>
          <option value="wednesday">Wednesday</option>
          <option value="thursday">Thursday</option>
          <option value="friday">Friday</option>
          <option value="saturday">Saturday</option>
        </select>
      </div>

      <!-- Fencers -->
      <label class="form-label" for="fencers">Fencers</label>
      <select class="form-select" id="fencers" v-model="selectedFencers" multiple>
        <option :value="fencer.id" v-for="fencer in fencers">{{fencer.firstname}} {{fencer.lastname}}</option>
      </select>

      <!-- Coaches -->
      <label class="form-label" for="coaches">Coaches</label>
      <select class="form-select" id="coaches" v-model="event.coaches" multiple required>
        <option :value="coach.id" v-for="coach in coaches">{{coach.firstname}} {{coach.lastname}}</option>
      </select>

      <!-- Seats -->
      <div class="form-group">
        <label class="form-label" for="seats">Number of spaces</label>
        <input class="form-input" type="number" id="seats" v-model="event.seats" required />
      </div>

      <!-- Description -->
      <div class="form-group">
        <label class="form-label" for="description">Description</label>
        <textarea class="form-input" type="date" id="description" v-model="event.description"></textarea>
      </div>

    </div>
    <div class="actions">
      <button class="btn" v-on:click.prevent="cancel">Cancel</button>&nbsp;
      <button class="btn btn-primary" type="submit">{{ buttonLabel }}</button>
    </div>
  </form>
</template>

<script>
import config from "../config.js"
import { EventBus } from '../main'

export default {
  name : "newClass",
  props : [
    "selected",
    "editing"
  ],
  data(){
    return {
      event : {
        type : "",
        level : "",
        space : "",
        days : [],
        coaches : [],
        fencers : []
      },
      levels : [],
      spaces : [],
      coaches : [],
      fencers : [],
      selectedFencers : [],
      buttonLabel : "Add",
      editAll : false,
    }
  },
  methods : {
    submitForm(e){
      // format the arrays for the database
      // need to be a comma seperated string
      this.daysOld = this.event.days
      this.event.days = this.event.days.join(",")
      this.coachesOld = this.event.coaches
      this.event.coaches = this.event.coaches.join(",")
      this.fencersOld = this.selectedFencers
      this.event.fencers = this.selectedFencers.join(",")
      if(this.editing){
        this.startTime = this.event.startTime
        delete this.event.startTime
        this.endTime = this.event.endTime
        delete this.event.endTime
        this.regClosed = this.event.regClosed
        delete this.event.regClosed
        delete this.event.scores
      }

      // make URL
      let url = config.baseUrl+"events/"
      if(this.editing) url += "update/"
      else url += "create/"
      let method = this.editing ? "PUT" : "POST"

      if(this.editing && this.editAll) this.event.changeAll = true

      fetch(url, {
        method : method,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        credentials : "include",
        body : JSON.stringify(this.event)
      }).then(e => {
        return e.json()
      }).then(j => {
        this.event.days = this.daysOld
        this.event.coaches = this.coachesOld
        this.selectedFencers = this.fencersOld

        if(this.editing){
          this.event.startTime = this.startTime
          this.event.endTime = this.endTime
          this.event.regClosed = this.regClosed
        }

        if(!this.editing) EventBus.$emit("eventCreated")
        else {
          EventBus.$emit("eventEdited", j[0])
        }
      }).catch(err => {
        // TODO: show error state
        console.log(err)
      })
    },
    getData(){
      fetch(config.baseUrl+"levels/", {
        credentials : "include"
      })
      .then(e => {
        return e.json()
      }).then(j => {
        fetch(config.baseUrl+"spaces/", {
          credentials : "include"
        })
        .then(e => {
          return e.json()
        }).then(j2 => {
          fetch(config.baseUrl+"user/coaches/list/mine/", {
            credentials : "include"
          })
          .then(e => {
            return e.json()
          }).then(j3 => {
            fetch(config.baseUrl+"/user/fencers/list/mine/", {
              credentials : "include"
            }).then(e => {
              return e.json()
            }).then(j4 => {
              this.setData(j, j2, j3, j4)
            })
          })
        })
      })
    },
    setData(d, d2, d3, d4){
      this.levels = d
      this.spaces = d2
      this.coaches = d3
      this.fencers = d4
      this.event.fencers.forEach(fencer => {
        this.selectedFencers.push(fencer.id)
      })
    },
    cancel(e){
      EventBus.$emit("closeModal", "close")
    }
  },
  created : function(){
    if(this.editing) {
      this.event = {}
      this.event = Object.assign(this.event, this.selected)
      this.event.club = this.selected.club.id
      this.event.level = this.selected.level.id
      this.event.space = this.selected.space.id
      delete this.event.color
      delete this.event.created
      delete this.event.formattedDate
      this.event.date = this.selected.date.split("T")[0]
      this.event.datestart = this.selected.datestart.split("T")[0]
      this.event.dateend = this.selected.dateend.split("T")[0]
      this.event.coaches = []
      this.selected.coaches.forEach(coach => {
        this.event.coaches.push(coach.id)
      })
      this.buttonLabel = "Save edits"
    }
    this.getData()
  }
}
</script>

<style lang="scss">
  .modal-container .actions {
    text-align: right;
  }
</style>
